import { render, staticRenderFns } from "./jobCardNew.vue?vue&type=template&id=fdd53884&scoped=true"
import script from "./jobCardNew.vue?vue&type=script&lang=js"
export * from "./jobCardNew.vue?vue&type=script&lang=js"
import style0 from "./jobCardNew.vue?vue&type=style&index=0&id=fdd53884&prod&scoped=true&lang=scss"
import style1 from "./jobCardNew.vue?vue&type=style&index=1&id=fdd53884&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd53884",
  null
  
)

export default component.exports